import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HttpClientJsonpModule,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './components/layout/layout.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { SignTableComponent } from './components/sign-table/sign-table.component';
import { GoogleMapComponent } from './components/google-map/google-map.component';
import { CreateSignComponent } from './screens/create-sign/create-sign.component';
import { LoginComponent } from './auth/login/login.component';
import { ToastComponent } from './core/toaster/toast.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { GeofencingService } from './components/google-map/geofencing.service';
import { LoginPageComponent } from './screens/login-page/login-page.component';
import { LoadingSpinnerComponent } from './core/loading-spinner/loading-spinner.component';
import { NotFoundPageComponent } from './screens/not-found-page/not-found-page.component';
import { NgChartsModule } from 'ng2-charts';
import { AgentDashboardComponent } from './screens/agent-dashboard/agent-dashboard.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { LayoutAdminComponent } from './components/layout-admin/layout-admin.component';
import { SignTableAdminComponent } from './components/sign-table-admin/sign-table-admin.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ScheduleWorkTableAdminComponent } from './components/schedule-work-table-admin/schedule-work-table-admin.component';
import { ScheduleTodoListAdminComponent } from './components/schedule-todo-list-admin/schedule-todo-list-admin.component';
import { RequestTypeComponent } from './components/request-type/request-type.component';
import { CollectStraySignComponent } from './components/collect-stray-sign/collect-stray-sign.component';
import { CollectChangeSignTableComponent } from './components/collect-change-sign-table/collect-change-sign-table.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SignTableConfirmDialogComponent } from './components/sign-table-confirm-dialog/sign-table-confirm-dialog.component';
import { InvoiceGenerateAdminComponent } from './components/invoice-generate-admin/invoice-generate-admin.component';
import { LayoutNotificationsPanelComponent } from './layout-notifications-panel/layout-notifications-panel.component';
import { DateToStringPipe } from './utils/date-to-string.pipe';
import { PrettyActionNamePipe } from './utils/pretty-action-name.pipe';
import { GetUserNamePipe } from './utils/get-user-name.pipe';
import { PrettyReadSignPipe } from './utils/pretty-read-sign.pipe';
import { MatChipsModule } from '@angular/material/chips';
import { FirstLoginPageComponent } from './screens/first-login-page/first-login-page.component';
import { SignActionsTableComponent } from './components/sign-actions-table/sign-actions-table.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WorkCompletedTableAdminComponent } from './components/work-completed-table-admin/work-completed-table-admin.component';
import { WorkCompletedConfirmUnscheduleDialogComponent } from './components/work-completed-confirm-unschedule-dialog/work-completed-confirm-unschedule-dialog.component';
import { SignActionsTableConfirmCancelDialogComponent } from './components/sign-actions-table-confirm-cancel-dialog/sign-actions-table-confirm-cancel-dialog.component';
import { SignTableNestedComponent } from './components/sign-table-nested/sign-table-nested.component';
import { SignTableNestedExampleComponent } from './components/sign-table-nested-example/sign-table-nested-example.component';
import { HomepageAgentComponent } from './components/homepage-agent/homepage-agent.component';
import { WorkCompletedConfirmRejectedDialogComponentComponent } from './components/work-completed-confirm-rejected-dialog-component/work-completed-confirm-rejected-dialog-component.component';
import { BoardActivityComponent } from './components/board-activity/board-activity.component';
import { AdminPanelComponent } from './screens/admin-panel/admin-panel.component';
import { UserModalComponent } from './screens/admin-panel/user-modal/user-modal.component';
import { ChangePasswordModalComponent } from './screens/admin-panel/change-password-modal/change-password-modal.component';
import { BoardActionSummaryComponent } from './screens/admin-panel/board-action-summary/board-action-summary.component';
import { LogsViewerComponent } from './components/logs-viewer/logs-viewer.component';

// Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LayoutAdminComponent,
    UnderConstructionComponent,
    SignTableComponent,
    GoogleMapComponent,
    CreateSignComponent,
    LoginComponent,
    ToastComponent,
    LoginPageComponent,
    LoadingSpinnerComponent,
    NotFoundPageComponent,
    AgentDashboardComponent,
    LineChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    SignTableAdminComponent,
    ScheduleWorkTableAdminComponent,
    ScheduleTodoListAdminComponent,
    RequestTypeComponent,
    CollectStraySignComponent,
    CollectChangeSignTableComponent,
    SignTableConfirmDialogComponent,
    InvoiceGenerateAdminComponent,
    LayoutNotificationsPanelComponent,
    DateToStringPipe,
    PrettyActionNamePipe,
    GetUserNamePipe,
    PrettyReadSignPipe,
    FirstLoginPageComponent,
    SignActionsTableComponent,
    WorkCompletedTableAdminComponent,
    WorkCompletedConfirmUnscheduleDialogComponent,
    SignActionsTableConfirmCancelDialogComponent,
    SignTableNestedComponent,
    SignTableNestedExampleComponent,
    HomepageAgentComponent,
    WorkCompletedConfirmRejectedDialogComponentComponent,
    BoardActivityComponent,
    AdminPanelComponent,
    UserModalComponent,
    ChangePasswordModalComponent,
    BoardActionSummaryComponent,
    LogsViewerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    NgChartsModule,
    MatDialogModule,
    MatChipsModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatBadgeModule,
    MatListModule,
    MatToolbarModule,
    MatSidenavModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    GeofencingService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // Initialize Firebase
  // const app = initializeApp(firebaseConfig);
  // const analytics = getAnalytics(app);
}
